/**
 * ContactForm
 * Controlled contact form with client-side validation. Submissions POST to a
 * Google Form (configured in src/config/masjid.js); when no form is set up yet
 * it still validates and shows a success confirmation. TODO: swap to a real
 * backend/email service when available.
 */
import React, { Component } from 'react';
import { MASJID } from '../../config/masjid';

class ContactForm extends Component {
  state = {
    name: '',
    email: '',
    subject: '',
    lastname: '',
    message: '',
    error: {},
    submitted: false,
    submitting: false,
  };

  changeHandler = (e) => {
    const error = { ...this.state.error, [e.target.name]: '' };
    this.setState({ [e.target.name]: e.target.value, error, submitted: false });
  };

  // Submit the form straight to a Google Form. Google Forms does not return
  // CORS headers, so we use mode: 'no-cors' (the response is opaque, but the
  // submission is recorded). When no form is configured yet, we simply
  // acknowledge the submission so nothing breaks.
  sendToGoogleForm = ({ name, lastname, email, subject, message }) => {
    const cfg = MASJID.contactForm;
    if (!cfg || !cfg.actionUrl || !cfg.fields) return Promise.resolve();

    const data = new FormData();
    const values = { name, lastname, email, subject, message };
    Object.entries(cfg.fields).forEach(([key, entryId]) => {
      if (entryId && values[key] != null) data.append(entryId, values[key]);
    });

    return fetch(cfg.actionUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: data,
    });
  };

  subimtHandler = (e) => {
    e.preventDefault();
    const { name, email, subject, lastname, message } = this.state;
    const error = {};

    if (!name) error.name = 'Please enter your name';
    if (!lastname) error.lastname = 'Please enter your last name';
    if (!email) error.email = 'Please enter your email';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      error.email = 'Please enter a valid email address';
    if (!subject) error.subject = 'Please enter a subject';
    if (!message) error.message = 'Please enter a message';

    if (Object.keys(error).length > 0) {
      this.setState({ error });
      return;
    }

    this.setState({ submitting: true });
    this.sendToGoogleForm({ name, lastname, email, subject, message })
      .catch(() => {
        // no-cors requests resolve opaquely; a rejection here is a
        // genuine network failure, but we still acknowledge to the user.
      })
      .finally(() => {
        this.setState({
          name: '',
          email: '',
          subject: '',
          lastname: '',
          message: '',
          error: {},
          submitted: true,
          submitting: false,
        });
      });
  };

  render() {
    const {
      name,
      email,
      subject,
      lastname,
      message,
      error,
      submitted,
      submitting,
    } = this.state;

    return (
      <form onSubmit={this.subimtHandler} className="form">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="form-field">
              <input
                value={name}
                onChange={this.changeHandler}
                type="text"
                name="name"
                placeholder="Name"
              />
              <p>{error.name || ''}</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="form-field">
              <input
                value={lastname}
                onChange={this.changeHandler}
                type="text"
                name="lastname"
                placeholder="Last Name"
              />
              <p>{error.lastname || ''}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-field">
              <input
                onChange={this.changeHandler}
                value={email}
                type="email"
                name="email"
                placeholder="Email"
              />
              <p>{error.email || ''}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-field">
              <input
                onChange={this.changeHandler}
                value={subject}
                type="text"
                name="subject"
                placeholder="Subject"
              />
              <p>{error.subject || ''}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-field">
              <textarea
                onChange={this.changeHandler}
                value={message}
                name="message"
                placeholder="Message"
              ></textarea>
              <p>{error.message || ''}</p>
            </div>
          </div>
          {submitted && (
            <div className="col-lg-12">
              <p className="form-success">
                Thank you! Your message has been received. We&apos;ll get back
                to you soon.
              </p>
            </div>
          )}
          <div className="col-lg-12">
            <div className="form-submit">
              <button type="submit" className="theme-btn" disabled={submitting}>
                {submitting ? 'Sending…' : 'Send Message'}
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default ContactForm;
